import { IonIcon, IonLabel, IonList, IonPopover } from "@ionic/react";
import { trashBin } from "ionicons/icons";

const ActionPopover = ({ 
  isOpen, 
  itemId, 
  trigger,
  onClose, 
  onDelete 
}: { 
  isOpen: boolean; 
  itemId: string; 
  trigger: string;
  onClose: () => void; 
  onDelete: (itemId: string) => void; 
}) => {
  const handleDelete = () => {
    onDelete(itemId);
    onClose();
  };

  return (
    <IonPopover
      isOpen={isOpen}
      trigger={trigger}
      onDidDismiss={onClose}
      showBackdrop={false}
      className="doc-popover"
    >
      <IonList className="doc-popover-list">
        <div
          className="doc-popover-list-item"
          onClick={handleDelete}
        >
          <IonIcon icon={trashBin} slot="start" color="danger"></IonIcon>
          <IonLabel className="doc-popover-list-item-label" color="danger">
            Delete
          </IonLabel>
        </div>
      </IonList>
    </IonPopover>
  );
};

export default ActionPopover;